import React from 'react';
import PropTypes from 'prop-types';

import Flag from '../../components/icons/flag';
import DisclaimerMessage from '../../components/react-disclaimer-msg';

import './index.scss';

const TopModule = ({disclaimerMsg}) => {
  const invalidDisclaimer = !disclaimerMsg || !Array.isArray(disclaimerMsg) || disclaimerMsg.length === 0;
  if (invalidDisclaimer) {
    return null;
  }

  const [firstMessage] = disclaimerMsg;
  const {header, message: msg} = firstMessage;

  return (
    <section className="RoyalTicketListTopModule">
      <div className="RoyalTicketListTopModule__icon">
        <Flag />
      </div>
      <div className="RoyalTicketListTopModule__container">
        <div className="RoyalTicketListTopModule__h4">{header}</div>
        {msg && <DisclaimerMessage disclaimerMsg={msg} />}
      </div>
    </section>
  );
};

TopModule.propTypes = {
  /** Array of messages */
  disclaimerMsg: PropTypes.array,
};

export default TopModule;
